<template>
    <div style="display:flex;">
        <div style="width: 20%;border: 1px solid #dcdee2;margin-top:1vw;margin-left: 1vw;border-radius: 8px">
            <el-tree :data="data" :props="defaultProps"
                     node-key="tcId"
                     :default-expanded-keys="tcIdList"
                     @node-click="treeNodeSelect">
            </el-tree>
        </div>
        <div class="tableOrgBox">
            <LabelContent title="工装分类" ref="LabelContent">
                <div slot="btns">
                    <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>
                </div>
            </LabelContent>
            <el-table stripe ref="multipleTable" :data="tableData" class="center"
                      @selection-change="handleSelectionChange" @sort-change="sortChange">
                <el-table-column prop="classifyName" sortable label="名称"/>
                <el-table-column prop="classifyCode" sortable label="编码"/>
                <el-table-column prop="classifyCode" sortable label="是否启用">
                    <template slot-scope="scope">
                        <span>{{scope.row.isActive == true ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="130">
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <i class="editBtn iconfont u-youjianbianji"
                               @click=";(ifAdd = false), updatehOpen(scope.row)"/>
                            <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)"/>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
        <el-dialog :title="ifAdd ? '新增' : '修改'" width="500px" :visible.sync="updateShow" style="text-align:left">
            <el-form :model="toolingClassify" :rules="classify" ref="classify" label-width="100px"
                     class="demo-roleForm">
                <el-form-item label="名称" prop="classifyName">
                    <el-input v-model="toolingClassify.classifyName"></el-input>
                </el-form-item>
                <el-form-item label="编码" prop="classifyCode">
                    <el-input v-model="toolingClassify.classifyCode" :disabled="codeShow"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-switch v-model="toolingClassify.isActive"
                               active-text="是"
                               inactive-text="否"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateShow = false">取 消</el-button>
                <el-button type="primary"
                           @click="updateToolingClassify('classify')">{{ ifAdd ? '新增' : '修改' }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { getAllToolingClassify, tooLingClassifyTree } from '../../../libs/api'

    export default {
        name: 'toolingClassify',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                tableData: [],
                classifyTree: [],
                ifAdd: false,
                toolingClassify: {
                    fcCode: '',
                    classifyCode: '',
                    classifyName: '',
                    isActive: '',
                    parentId: ''
                },
                classify: {
                    classifyCode: [
                        {
                            type: 'string',
                            required: true,
                            message: '请输入编码',
                            trigger: 'blur'
                        }
                    ],
                    classifyName: [
                        {
                            type: 'string',
                            required: true,
                            message: '请输入名称',
                            trigger: 'blur'
                        }
                    ]
                },
                updateShow: false,
                codeShow: false,
                data: [],
                tcIdList: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                tcId: '',
                fcCode: '',
                treeNodeSelected: {},
                userInfo: {},
                roles: {}
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                this.userInfo = this.$store.state.userInfo
                if (this.userInfo.factoryId == 0) {
                    //所有工厂数据
                } else {
                    var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                    this.roles = userInfo.roles
                    for (let i = 0; i < userInfo.roles.length; i++) {
                        if (i == userInfo.roles.length - 1) {
                            this.fcCode += userInfo.roles[i].fcCode
                        } else {
                            this.fcCode += userInfo.roles[i].fcCode + ','
                        }
                    }
                }
                this.tooLingClassifyTree()
                this.searchTable()
            },
            treeNodeSelect(nodes) {
                this.treeNodeSelected = nodes
                this.tcId = nodes.tcId
                this.searchTable()
            },
            //分页
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            updatehOpen(row) {
                //新增
                if (this.ifAdd) {
                    if (this.tcId == undefined || this.tcId == '') {
                        this.$message.error('请选择分类！')
                        return
                    }
                    if (this.treeNodeSelected.classifyLevel == 'c') {
                        return
                    }
                    this.toolingClassify = {}
                    this.updateShow = true
                    this.codeShow = false
                    this.toolingClassify.parentId = this.tcId
                    if (this.userInfo.factoryId != 0) {
                        this.toolingClassify.fcCode = this.userInfo.fcCode
                    }
                }
                //编辑
                else {
                    this.toolingClassify = JSON.parse(JSON.stringify(row))
                    this.updateShow = true
                    this.codeShow = true
                }
            },
            updateToolingClassify(classify) {
                if (this.ifAdd) {
                    this.$refs[classify].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                url: this.$api.addToolingClassify,
                                data: this.toolingClassify
                            }
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    this.tooLingClassifyTree()
                                    this.treeNodeSelect(this.treeNodeSelected)
                                    this.$message.success('新增成功！')
                                    this.updateShow = false
                                } else {
                                    this.$message.error(response.message)
                                }
                            })
                        } else {
                            return false
                        }
                    })
                } else {
                    this.$refs[classify].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                url: this.$api.editToolingClassify,
                                data: this.toolingClassify
                            }
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    this.tooLingClassifyTree()
                                    this.treeNodeSelect(this.treeNodeSelected)
                                    this.$message.success('编辑成功！')
                                    this.updateShow = false
                                } else {
                                    this.$message.error(response.message)
                                }
                            })
                        } else {
                            return false
                        }
                    })
                }
            },
            deleteRow(row) {
                let params = {
                    classifyId: row.tcId
                }
                let options = {
                    method: 'get',
                    url: this.$api.getToolingClassifyList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data == undefined || response.data == '') {
                            this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                                confirmButtonText: '删除',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.$http
                                    .request({
                                        method: 'POST',
                                        headers: { 'content-type': 'application/json' },
                                        params: { tcId: row.tcId },
                                        url: this.$api.deleteToolingClassify
                                    })
                                    .then(response => {
                                        this.tooLingClassifyTree()
                                        this.treeNodeSelect(this.treeNodeSelected)
                                        // this.$message.success(response.message);
                                    })
                                    .catch(err => {
                                        this.tooLingClassifyTree()
                                        this.treeNodeSelect(this.treeNodeSelected)
                                        // this.$message.error(err);
                                    })
                            }).catch(() => {
                                this.tooLingClassifyTree()
                                this.treeNodeSelect(this.treeNodeSelected)
                                this.$message({
                                    type: 'info',
                                    message: '已取消删除'
                                })
                            })
                        } else {
                            this.$message.error('请先删除工装清单！')
                        }
                    }
                })
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                if (this.tcId != undefined && this.tcId != '') {
                    queryParams['tcId'] = this.tcId
                } else {
                    return
                }
                if (this.userInfo.factoryId != 0) {
                    queryParams['fcCode'] = this.userInfo.fcCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getAllToolingClassify,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            tooLingClassifyTree() {
                var params = {}
                if (this.userInfo.factoryId != 0) {
                    params['fcCode'] = this.userInfo.fcCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.tooLingClassifyTree,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.setToolingClassify(response.data)
                    }
                })
            },
            setToolingClassify(toolTypes) {
                toolTypes.forEach(result => {
                    if (result.hasOwnProperty('tcId')) {
                        if (result.child != undefined && result.child != '') {
                            if (result.child[0].hasOwnProperty('tcId')) {
                                this.tcIdList.push(result.tcId)
                            }
                        }
                    }
                    if (result.hasOwnProperty('classifyCode')) {
                        result.label = result.classifyName
                        result.value = result.classifyCode
                        result.children = result.child
                        if (result.child != null) {
                            if (result.child.length > 0) {
                                this.setToolingClassify(result.child)
                            }
                        }
                    }
                })
                this.data = toolTypes
            }
        }
    }
</script>

<style scoped>

</style>
